module.exports = __webpack_public_path__ + "img/advisory-unpay.c372feac.png";